import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DrawerBody,
  DrawerFooter,
  Box,
  Text,
  Flex,
} from '@chakra-ui/react';
import { CirlceIcon, icons } from '../utils/Icon';
import { TState, useActions } from '../../redux/store';
// import UrlBtn from './UrlBtn';
import PlanningBtn from './PlanningBtn';

type TModal = {
  children?: ReactNode;
  options: Record<
    string,
    {
      component?: any;
      action?: any;
      canDelete?: string;
      title: string | JSX.Element;
      actionLabel?: string;
      pending?: boolean;
      hint?: string | JSX.Element;
      url?: boolean;
      planning?: boolean;
    }
  >;
};

export const ModalCrm = ({ children, options }: TModal) => {
  const isOpen = useSelector((state: TState) => state.isOpen);
  const modalType = useSelector((state: TState) => state.modalType);
  const theme = useSelector((state: TState) => state.theme);
  const isMobile = useSelector((state: TState) => state.isMobile);
  const modalData = useSelector((state: TState) => state.modalData);

  const { onClose, setModalType } = useActions();

  const {
    action,
    title,
    actionLabel,
    component,
    canDelete,
    pending,
    hint,
    // url,
    planning,
  } = options?.[modalType] || {};

  return !options?.[modalType] ? null : (
    <Drawer
      isOpen={isOpen}
      onClose={modalData?.isExternal ? null : onClose}
      blockScrollOnMount={false}
      closeOnOverlayClick={false}
    >
      {/* <ModalOverlay /> */}
      <DrawerContent
        flexDirection='column'
        maxW={
          // /user|action|input|editFilters|Tab$/i.test(modalType)
          /(planning|computeBeforeImport)$/i.test(modalType)
            ? '100%'
            : /displayMajs$/i.test(modalType)
              ? { sm: '100%', lg: '35%' }
              : { sm: '100%', lg: '70%' }
        }
        boxShadow='dark-lg'
      >
        {title && (
          <DrawerHeader h='62px' textTransform='capitalize'>
            {title}
          </DrawerHeader>
        )}
        {!modalData?.isExternal && <DrawerCloseButton />}
        <DrawerBody py={0} flexGrow={1}>
          {component || children}
        </DrawerBody>

        <DrawerFooter
          alignItems='center'
          id='drawerFooter'
          h='62px'
          gap={5}
          justifyContent='space-between'
        >
          <Flex gap={1} alignItems='center'>
            {canDelete && (
              <CirlceIcon
                backgroundColor='red.500'
                color='white'
                cursor='pointer'
                _hover={{
                  backgroundColor: 'white',
                  color: 'red.500',
                  fontSize: '1.5rem',
                  // marginTop: 1,
                }}
                // transition='all ease .3s'
                icon={icons.trash}
                onClick={() => setModalType(canDelete)}
              />
            )}
            {/* External links are disabled until their tokens are strictly scoped. */}
            {/* {url && <UrlBtn />} */}
            {planning && <PlanningBtn />}
          </Flex>
          {!isMobile && <Box flexGrow={1} />}
          {typeof hint === 'string' ? (
            <Text fontStyle='italic' fontSize={theme.fontSize.xSmall}>
              {hint ||
                (isMobile
                  ? 'Champs importants'
                  : 'Champs importants pour la complétion du dossier')}
            </Text>
          ) : (
            hint
          )}
          {action && (
            <Button
              backgroundColor={theme.light}
              color={theme.main}
              _hover={{ backgroundColor: theme.dark, color: theme.none }}
              onClick={action}
              isLoading={pending}
            >
              {actionLabel || 'Valider'}
            </Button>
          )}
          {/* <Button colorScheme="blue" onClick={onClose}>
						Cancel
					</Button> */}
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default ModalCrm;
